import React from 'react';

import { Button as StyledButton, Img } from './styles';

interface Props {
  onClick: (event: React.MouseEvent) => void;
  style?: React.CSSProperties;
}

const Button = (props: Props) => (
  <StyledButton {...props}>
    <Img width={'35px'} src="/corporate/images/customer-support.svg" alt="icon" />
  </StyledButton>
);

export default Button;
